const urlUtils = require('../../utils/url');
const offcanvasdialog = require('../offcanvasdialog');
const quickshop = require('./quickshop');

const quickShopWishlist = {
    /**
     * Load quickShop from wishlist
     *
     * @param {string} pid product id
     * @param {Function?} callback callback function
     */
    init(pid, callback = null) {
        let quickShopUrl = Urls.quickShop;
        quickShopUrl = urlUtils.appendParamToURL(quickShopUrl, 'pid', pid);

        const quickShopFlyin = offcanvasdialog.init(false, {
            overlay: true,
            overlayClasses: 'is-active',
            additionalClass: 'quick-shop'
        });

        quickShopFlyin.loadContent(quickShopUrl, () => {
            const $qsFlyInContent = $('.ocd-content');
            quickShopFlyin.show();
            quickshop.initFlyIn($qsFlyInContent);
            $qsFlyInContent[0].addEventListener('quick-shop-done', e => {
                callback?.(e.pid);
            });
        });
    }
};

module.exports = quickShopWishlist;
